import AdapterError from '@ember-data/adapter/error';

export default AdapterError.extend({ message: 'The fund token has expired.' });
